// Mirror of QUOTE_STATE_TRANSITIONS in the API (src/quotes/constants/quote.constants.ts).
// Manual transitions allowed for the operator. Automatic transitions
// (store → customer on owner assignment, anything → buy_on on order
// confirmation) are NOT in this map.
//   - `store`/`quoting` are never valid as a target (irrecoverable).
//   - `buy_on`/`bought_assisted` are auto-only; never a manual target.
//   - `archived`/`lost` cannot reach `buy_on` directly.
//   - `open`/`open_store`/`customer_store` son los valores legacy de Cliente (el chip los
//     muestra como "Cliente"): salen a donde sale `customer`, más `customer` mismo.
export const QUOTE_STATE_TRANSITIONS: Record<string, readonly string[]> = {
  quoting: ["customer"],
  store: ["customer"],
  open: ["customer", "follow", "archived", "lost", "buy_off"],
  open_store: ["customer", "follow", "archived", "lost", "buy_off"],
  customer_store: ["customer", "follow", "archived", "lost", "buy_off"],
  customer: ["follow", "archived", "lost", "buy_off"],
  follow: ["customer", "archived", "lost", "buy_off"],
  archived: ["customer", "follow", "lost", "buy_off"],
  lost: ["customer", "follow", "archived", "buy_off"],
  buy_off: ["customer", "follow", "archived", "lost"],
  buy_on: [],
  bought_assisted: [],
};

export const isAllowedQuoteStateTransition = (
  from: string | null | undefined,
  to: string,
): boolean => {
  const key = (from ?? "quoting").toString();
  const allowed = QUOTE_STATE_TRANSITIONS[key];
  return Array.isArray(allowed) && allowed.includes(to);
};
